const UUID_V4_REGEX = /[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}/i;

const FACILITIES_APP_POC_CARERS_WIDGET_URL = import.meta.env.VITE_FACILITIES_APP_POC_PUBLIC_URL;

export { UUID_V4_REGEX, FACILITIES_APP_POC_CARERS_WIDGET_URL };
